export default __webpack_public_path__ + "static/media/ITA.bb2033dc.svg";